import {apiMethodsWithToken} from 'services/api'

export const logInUser = (response, setUser, setLoading = () => {}) => {
  if (response?.success) {
    setUser(u => ({...u, ...response.data}))
    apiMethodsWithToken.token = response.data?.accessToken
    localStorage.setItem('user', JSON.stringify({
      email: response.data?.email,
      accessToken: response.data?.accessToken,
      refreshToken: response.data?.refreshToken,
    }))
  } else {
    console.warn(response)
  }
  setLoading(false)
}

export const updateUserInfo = (response, setUser, setLoading = () => {}) => {
  if (response?.success) {
    setUser(u => ({...u, ...response.data}))
  }
  setLoading(false)
}

export const logOutUser = (setUser, setDelivery) => {
  localStorage.removeItem('user')
  localStorage.removeItem('zip')
  setUser(null)
  setDelivery(null)
}

export const nameRenderer = user => user.surname ? user.name ? `${user.name} ${user.surname}` : user.surname : user.email
